import { Component, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { MailboxRegister } from '../mailbox-register';
import { MailboxFilterOptions } from '../models/mailbox-filter-option';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-mailbox-register',
    styleUrls: ['./mailbox-register.component.scss'],
    templateUrl: './mailbox-register.component.html',
    standalone: false
})
export class MailboxRegisterComponent extends MailboxRegister {
   accountId: number | null;

   constructor(public store: Store) {
      super(store);
      store
         .select(getSelectedAccountId)
         .pipe(
            filter((accountId: number | null): accountId is number => {
               return accountId != null;
            }),
            map((accountId: number) => {
               const filters: MailboxFilterOptions[] = [
                  {
                     field: 'Extension.AccountId',
                     operation: FilterOperations.EqualTo,
                     type: 'numeric',
                     value: accountId,
                  },
               ];
               return filters;
            })
         )
         .subscribe((filters) => {
            this.filters = filters;
         });
      this.columns = ['name', 'number', 'type', 'emailAddress', 'messageCount', 'mailboxActionsMenu'];
   }
}
